import { cva } from "class-variance-authority";

export const stylesDemoTrading = cva(
  "px-[6px] py-[2px] rounded-[4px] text-[14px] leading-[20px] text-light-second ml-[24px]",
  {
    variants: {
      mode: {
        light: "bg-gradient-to-r from-[#FFE44C] via-[#F80] via-[63%] to-[#EB3063]",
        dark: "bg-gradient-to-r from-[#FFE44C] via-[#F80] via-[63%] to-[#EB3063]"
      }
    }
  }
);

export const stylesLiveTrading = cva(
  "flex justify-center items-center px-[12px] py-[5px] rounded-[4px] text-[14px] leading-[20px] mr-[24px] cursor-pointer",
  {
    variants: {
      mode: {
        light: "text-light-primary bg-light-primary-14",
        dark: "text-dark-primary bg-dark-primary-14"
      }
    }
  }
);
